export class ValidationHelper {
  constructor(){}

  isValidDate = (date) => date && new Date(date) instanceof Date;
}
